<template>
  <div>
    <h5 class="u-margin-bottom-small">
      {{ $t("auxiliaryCoolingEquipment.files") }}
    </h5>

    <loading v-if="isLoading"></loading>
    <NotFound v-else-if="files.length === 0"></NotFound>
    <ul class="c-list" v-else>
      <li class="c-list__item" v-for="file in files" :key="file.id">
        <div class="u-line-1">
          <i class="icofont-file-pdf u-color-danger"></i>
          <small class="u-margin-left-xsmall">{{ file.title }} </small>
        </div>
        <div>
          <Button
            variant="light-primary"
            class="u-margin-right-xsmall"
            size="sm"
            @click="viewFile(file)"
          >
            <i class="icofont-eye"></i>
          </Button>
          <Button
            variant="light-danger"
            :loading="isLoadingCreate"
            size="sm"
            @click="removeFile(file)"
          >
            <i class="icofont-trash"></i>
          </Button>
        </div>
      </li>
    </ul>
    <div class="u-margin-top u-text-align-center">
      <Button
        variant="light-primary"
        size="sm"
        :loading="isLoadingCreate"
        @click="$refs.fileInput.click()"
      >
        <i class="icofont-plus"></i>
        {{ $t("auxiliaryCoolingEquipment.addFile") }}
      </Button>
      <input
        type="file"
        class="u-display-none"
        accept="application/pdf"
        ref="fileInput"
        @change="handleFileChange"
      />
    </div>
  </div>
</template>

<script>
import Requests from "@/services/Requests";
import NotFound from "../Base/NotFound.vue";
import Button from "../Base/Button.vue";
import $api from "@/services/Api";
export default {
  components: {
    NotFound,
    Button,
  },
  props: {
    auxiliaryCoolingEquipment: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoadingCreate: false,
      isLoading: true,
      files: [],
      file: null,
    };
  },
  methods: {
    async getFiles() {
      this.isLoading = true;
      const response = await Requests.TechinalDrawing.GetAll({
        query: {
          auxiliaryCoolingEquipmentId: this.auxiliaryCoolingEquipment.id,
        },
      });
      if (response.message === "OK") {
        this.files = response.data.items;
      }
      this.isLoading = false;
    },
    async addFile() {
      this.file = null;
    },
    async handleFileChange(event) {
      this.file = event.target.files[0];
      this.isLoadingCreate = true;
      const formData = new FormData();
      formData.append("file", this.file);
      formData.append("title", this.file.name);
      formData.append(
        "auxiliaryCoolingEquipmentId",
        this.auxiliaryCoolingEquipment.id
      );

      const respons = await Requests.TechinalDrawing.Create(formData);
      if (respons.message === "OK") {
        this.getFiles();
      }
      this.isLoadingCreate = false;
    },
    viewFile(file) {
      window.open($api.image(file.filePath), "_blank");
    },
    async removeFile(file) {
      this.isLoadingCreate = true;
      const respons = await Requests.TechinalDrawing.Delete({
        params: {
          id: file.id,
        },
      });
      if (respons.message === "OK") {
        this.getFiles();
      }
      this.isLoadingCreate = false;
    },
  },
  mounted() {
    this.getFiles();
  },
};
</script>

<style></style>
